module.exports = __webpack_public_path__ + "img/coins.580cd325.png";